<template>
  <div class="radiobox">
    <label :style="width?{width}:{}"  v-for="(opt, o) in options"  :key="o"  :for="opt"><input type="radio" v-model="value" :id="opt" :value="opt"
    @click="clicked(opt)"
    :style="[round?{borderRadius: '30px'}:{}, height?{height}:{}]">
    {{opt}}</label>
  </div>
</template>

<script>
export default {
  props: ['options', 'defaultValue', 'round', 'height', 'width'],
  data () {
    return {
      value: null
    }
  },
  watch: {
    defaultValue () {
      this.value = this.defaultValue
    },
    value () {
      if (this.value !== this.defaultValue) {
        this.$emit('input', this.value)
      }
    }
  },
  mounted () {
    this.value = this.defaultValue
  },
  methods: {
    clicked (opt) {
      if (opt === this.defaultValue) {
        this.$emit('same', opt)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.radiobox {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;
}
label {
  white-space: nowrap;
  color: #6D6D6D;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  height: 40px;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.1em;
}
input[type=radio] {
  appearance: none;
  width: 24px;
  height: 24px;
  border: 2px solid var(--color-pri);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 6px;
    background-color: #FFFFFF;
  }
  &:checked{
    background-color: var(--color-pri);
  }
}
</style>
